import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";
import MKAlert from "components/MKAlert";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
//FormLabel

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";
import MKDatePicker from "components/MKDatePicker";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/examples/blog-9-4.jpg";
//import bgImage1 from "assets/images/examples/content-2.jpg";

//icons
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import TodayIcon from "@mui/icons-material/Today";
import LanguageIcon from "@mui/icons-material/Language";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

//motion
import { motion } from "framer-motion";

function Employee() {
  // server from env
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  //vars declaration
  const [fullName, setFullName] = useState("");
  const [salaryExpectation, setSalaryExpectation] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [languages, setLanguages] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [position, setPosition] = useState([]);
  const [positionOptions, setPositionOptions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [resume, setResume] = useState(null);
  const [alertMsg, setAlertMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [sex, setSex] = useState("");

  //--- function to handle submit ---
  const handleFormSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);
    setIsSubmitted(false);

    const formData = new FormData();
    formData.append("names", fullName);
    formData.append("salaryExpectation", salaryExpectation);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("address", address);
    formData.append("startDate", startDate);
    formData.append("gender", sex);
    formData.append("resume", resume);
    formData.append("languages", JSON.stringify(languages));
    formData.append("positions", JSON.stringify(position));

    axios
      .post(`${SERVER_URL}/employee/add/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data === "Done") {
          setAlertMsg("Application Sent! We'll Get Back to You Very Soon");
          setIsSubmitted(true);
        } else {
          alert("Application failed, please try again.");
        }
      })
      .catch((err) => {
        console.error("Submission error:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // languages
  useEffect(() => {
    axios
      .get(`${SERVER_URL}/helper/get-language/`)
      .then((res) => {
        if (res.status === 200) {
          setLanguageOptions(res.data);
        }
      })
      .catch((err) => console.error("Error fetching languages:", err));
  }, []);

  // positions
  useEffect(() => {
    axios
      .get(`${SERVER_URL}/helper/get-position/`)
      .then((res) => {
        if (res.status === 200) {
          setPositionOptions(res.data);
        }
      })
      .catch((err) => console.error("Error fetching position:", err));
  }, []);

  return (
    <>
      <>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/booking",
            label: "BOOK NOW",
            color: "info",
          }}
          transparent
          light
        />
        <MKBox
          minHeight="50vh"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        >
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={8}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={{ mx: "auto", textAlign: "center" }}
            >
              <MKTypography
                variant="h2"
                color="white"
                mb={2}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Discover Comfort and Convenience
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <Card
          sx={{
            p: { xs: 2, md: 4 },
            mx: { xs: 1, md: 4 },
            mt: -8,
            mb: 4,
            borderRadius: "2rem",
            backgroundColor: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(25px) saturate(200%)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          }}
        >
          <MKBox component="section" py={{ xs: 4, lg: 6 }}>
            <Container>
              <MKBox component="section" py={{ xs: 4, lg: 6 }}>
                <Container>
                  <Card
                    sx={{
                      p: { xs: 2, md: 4 },
                      mx: { xs: 1, md: 4 },
                      mt: -8,
                      borderRadius: "2rem",
                      backgroundColor: "rgba(255,255,255,0.85)",
                      backdropFilter: "blur(25px) saturate(200%)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    }}
                  >
                    <MKBox component="form" onSubmit={handleFormSubmit}>
                      {alertMsg.length > 0 && (
                        <motion.div
                          initial={{ x: -200, opacity: 0 }}
                          animate={{ x: 0, opacity: 1 }}
                          transition={{ duration: 1.5, ease: "easeOut" }}
                        >
                          <MKAlert color="info">{alertMsg}</MKAlert>
                        </motion.div>
                      )}

                      {/* Title with right-aligned link */}
                      <MKBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <MKTypography variant="h3" fontWeight="medium">
                          Job Application
                        </MKTypography>

                        <MKTypography
                          component={Link} // Use React Router Link
                          to="/employer"
                          variant="body2"
                          sx={{
                            textDecoration: "underlinea",
                            textUnderlineOffset: "3px",
                            textDecorationColor: "#1E88E5",
                            color: "#1E88E5",
                            fontWeight: 500,
                            cursor: "pointer",
                            "&:hover": {
                              opacity: 0.8,
                              textDecorationColor: "#1565C0",
                            },
                          }}
                        >
                          Need Help instead?
                        </MKTypography>
                      </MKBox>

                      <MKTypography variant="body2" mb={4} color="text.secondary">
                        Apply for your desired position. Provide all required details below.
                      </MKTypography>

                      <Grid container spacing={3}>
                        {/* Full Name + Email */}
                        <Grid item xs={12} md={6}>
                          <MKInput
                            onChange={(e) => setFullName(e.target.value)}
                            variant="outlined"
                            label="Full Name"
                            fullWidth
                            startAdornment={<PersonIcon sx={{ mr: 1, color: "gray" }} />}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            onChange={(e) => setEmail(e.target.value)}
                            variant="outlined"
                            label="Email"
                            fullWidth
                            startAdornment={<EmailIcon sx={{ mr: 1, color: "gray" }} />}
                          />
                        </Grid>

                        {/* Telephone + Address */}
                        <Grid item xs={12} md={6}>
                          <MKInput
                            onChange={(e) => setPhone(e.target.value)}
                            variant="outlined"
                            label="Telephone"
                            fullWidth
                            startAdornment={<PhoneIcon sx={{ mr: 1, color: "gray" }} />}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            onChange={(e) => setAddress(e.target.value)}
                            variant="outlined"
                            label="Address"
                            fullWidth
                            startAdornment={<LocationOnIcon sx={{ mr: 1, color: "gray" }} />}
                          />
                        </Grid>

                        {/* Languages You Speak + Position */}
                        <Grid item xs={12} md={6}>
                          <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                            <LanguageIcon sx={{ mr: 1 }} /> Languages You Speak
                          </MKTypography>
                          <Autocomplete
                            multiple
                            options={languageOptions}
                            getOptionLabel={(option) => option.name}
                            onChange={(e, value) =>
                              setLanguages(value.map((v) => ({ id: v.id, name: v.name })))
                            }
                            renderInput={(params) => <MKInput {...params} variant="outlined" />}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                            <WorkIcon sx={{ mr: 1 }} /> Position
                          </MKTypography>
                          <Autocomplete
                            multiple
                            options={positionOptions}
                            getOptionLabel={(option) => option.name}
                            onChange={(e, value) =>
                              setPosition(value.map((v) => ({ id: v.id, name: v.name })))
                            }
                            renderInput={(params) => <MKInput {...params} variant="outlined" />}
                          />
                        </Grid>
                        {/* Start Date */}
                        <Grid item xs={12} md={6}>
                          <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                            <TodayIcon sx={{ mr: 1 }} /> Available Start Date
                          </MKTypography>
                          <MKDatePicker
                            variant="standard"
                            input={{ placeholder: "Select start date" }}
                            fullWidth
                            onChange={(date) => setStartDate(date[0])}
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <MKTypography variant="button" mb={1} display="block">
                            Gender
                          </MKTypography>
                          <RadioGroup
                            row
                            onChange={(e) => setSex(e.target.value)}
                            value={sex}
                            name="sex"
                          >
                            <FormControlLabel
                              value="Male"
                              control={<Radio color="primary" />}
                              label="Male"
                            />
                            <FormControlLabel
                              value="Female"
                              control={<Radio color="primary" />}
                              label="Female"
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            onChange={(e) => setSalaryExpectation(e.target.value)}
                            variant="outlined"
                            label="Salary Expectation"
                            fullWidth
                            startAdornment={<PersonIcon sx={{ mr: 1, color: "gray" }} />}
                          />
                        </Grid>

                        {/* Resume Upload - Apple Modern Style */}
                        <Grid item xs={12}>
                          <MKBox
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            p={4}
                            sx={{
                              border: "2px dashed #007AFF",
                              borderRadius: "1.5rem",
                              backgroundColor: "rgba(245,245,245,0.6)",
                              cursor: "pointer",
                              transition: "0.3s",
                              "&:hover": { backgroundColor: "rgba(230,230,250,0.7)" },
                            }}
                            onClick={() => document.getElementById("resumeUpload").click()}
                          >
                            <UploadFileIcon sx={{ fontSize: 48, color: "#007AFF", mb: 2 }} />
                            <MKTypography variant="body2" color="text.secondary" textAlign="center">
                              Click here to upload your CV / Resume
                            </MKTypography>
                            <input
                              type="file"
                              id="resumeUpload"
                              onChange={(e) => setResume(e.target.files[0])}
                              style={{ display: "none" }}
                            />
                            {resume && (
                              <MKTypography mt={1} variant="body2" color="text">
                                Selected file: {resume.name}
                              </MKTypography>
                            )}
                          </MKBox>
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12} display="flex" justifyContent="center">
                          <MKButton
                            variant="gradient"
                            color={isSubmitted ? "primary" : "info"}
                            type="submit"
                            disabled={isLoading || isSubmitted}
                          >
                            {isLoading ? "Submitting..." : isSubmitted ? "Submitted" : "Apply Now"}
                          </MKButton>
                        </Grid>
                      </Grid>
                    </MKBox>
                  </Card>

                  {/* Other Information Section (keep as in service booking) */}
                  <Card
                    sx={{
                      p: { xs: 3, md: 5 },
                      mx: { xs: 1, md: 4 },
                      my: 4,
                      borderRadius: "2rem",
                      backgroundColor: "rgba(255,255,255,0.9)",
                      backdropFilter: "blur(25px) saturate(200%)",
                      boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                    }}
                  >
                    <MKBox display="flex" flexDirection="column" alignItems="center">
                      <MKTypography variant="h4" mb={4} fontWeight="medium" textAlign="center">
                        Other Ways to Reach Us
                      </MKTypography>

                      <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} md={4}>
                          <MKBox
                            display="flex"
                            alignItems="center"
                            gap={2}
                            p={2}
                            borderRadius="1rem"
                            sx={{
                              backgroundColor: "rgba(245,245,245,0.6)",
                              justifyContent: "center",
                            }}
                          >
                            <PhoneIcon sx={{ fontSize: "1.5rem", color: "#007AFF" }} />
                            <MKTypography>(+250) 795 305 418</MKTypography>
                          </MKBox>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <MKBox
                            display="flex"
                            alignItems="center"
                            gap={2}
                            p={2}
                            borderRadius="1rem"
                            sx={{
                              backgroundColor: "rgba(245,245,245,0.6)",
                              justifyContent: "center",
                            }}
                          >
                            <EmailIcon sx={{ fontSize: "1.5rem", color: "#007AFF" }} />
                            <MKTypography>
                              info@helpereverywhere.com
                              <br />
                              helpereverywheremail@gmail.com
                            </MKTypography>
                          </MKBox>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <MKBox
                            display="flex"
                            alignItems="center"
                            gap={2}
                            p={2}
                            borderRadius="1rem"
                            sx={{
                              backgroundColor: "rgba(245,245,245,0.6)",
                              justifyContent: "center",
                            }}
                          >
                            <LocationOnIcon sx={{ fontSize: "1.5rem", color: "#007AFF" }} />
                            <MKTypography>KG 314 St, Kigali, Rwanda</MKTypography>
                          </MKBox>
                        </Grid>
                      </Grid>

                      {/* Social Buttons */}
                      <MKBox display="flex" justifyContent="center" gap={2} mt={4}>
                        <MKButton
                          variant="text"
                          color="primary"
                          iconOnly
                          component="a"
                          href="https://wa.me/250795305418"
                          target="_blank"
                        >
                          <WhatsAppIcon sx={{ fontSize: "1.5rem" }} />
                        </MKButton>
                        <MKButton
                          variant="text"
                          color="primary"
                          iconOnly
                          component="a"
                          href="https://facebook.com/helpereverywhere"
                          target="_blank"
                        >
                          <FacebookIcon sx={{ fontSize: "1.5rem" }} />
                        </MKButton>
                        <MKButton
                          variant="text"
                          color="primary"
                          iconOnly
                          component="a"
                          href="https://instagram.com/helpereverywhere"
                          target="_blank"
                        >
                          <InstagramIcon sx={{ fontSize: "1.5rem" }} />
                        </MKButton>
                      </MKBox>
                    </MKBox>
                  </Card>
                </Container>
              </MKBox>
            </Container>
          </MKBox>
        </Card>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </>
    </>
  );
}

export default Employee;
